import axios from '../helpers/axios';
import { logError } from '../services';
import { IOptionList, IResponse, IDropdownResponse, IOptionDropdown, IOptionInfo } from '../models';

export const getOptionsList = async (filters?: {
  name?: string;
  optionSetId?: number;
  phaseId?: number;
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number | string;
}): Promise<IResponse<IOptionList[]>> => {
  try {
    const { data } = await axios.get(`/api/options`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getOptionsList failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getOptionSets = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/options/lookups/option-sets`);
    return data;
  } catch (error) {
    logError(error, 'getOptionSets failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getOptionPhases = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/options/lookups/phases`);
    return data;
  } catch (error) {
    logError(error, 'getOptionPhases failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getCostTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/options/lookups/cost-types`);
    return data;
  } catch (error) {
    logError(error, 'getCostTypes failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getPriceTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/options/lookups/price-types`);
    return data;
  } catch (error) {
    logError(error, 'getPriceTypes failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getTaskCutoff = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/options/lookups/task-cutoff`);
    return data;
  } catch (error) {
    logError(error, 'getTaskCutoff failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getColorPalettes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/options/lookups/color-palettes`);
    return data;
  } catch (error) {
    logError(error, 'getColorPalettes failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getUnitsOfMeasure = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/options/lookups/units-of-measure`);
    return data;
  } catch (error) {
    logError(error, 'getUnitsOfMeasure failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getCostingRules = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/options/lookups/costing-rules`);
    return data;
  } catch (error) {
    logError(error, 'getCostingRules failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getOptionTerritories = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/options/lookups/territories`);
    return data;
  } catch (error) {
    logError(error, 'getOptionTerritories failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getNotificationTasks = async (): Promise<IOptionDropdown[]> => {
  try {
    const { data } = await axios.get(`/api/options/lookups/notification-tasks`);
    return data;
  } catch (error) {
    logError(error, 'getNotificationTasks failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getAffectedTasks = async (): Promise<IOptionDropdown[]> => {
  try {
    const { data } = await axios.get(`/api/options/lookups/affected-tasks`);
    return data;
  } catch (error) {
    logError(error, 'getAffectedTasks failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getOptionLockouts = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/options/lookups/options`);
    return data;
  } catch (error) {
    logError(error, 'getOptionLockouts failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getOptionInfo = async (optionId: number | string): Promise<IOptionInfo> => {
  try {
    const { data } = await axios.get(`/api/options/${optionId}`);
    return data;
  } catch (error) {
    logError(error, 'getOptionPhases failed');
    return Promise.reject(error?.response?.data);
  }
};

export const createOption = async (payload: IOptionInfo): Promise<any> => {
  try {
    return await axios.post(`/api/options`, payload);
  } catch (error) {
    logError({ error }, 'createOption failed');
    return Promise.reject(error?.response?.data);
  }
};

export const updateOptionImage = async (
  optionId: string | number,
  imagePost: FormData
): Promise<string[]> => {
  try {
    const { data } = await axios.put(`/api/options/image/${optionId}`, imagePost);
    return data;
  } catch (error) {
    logError({ error, payload: imagePost }, 'addOptionLetter failed');
    return Promise.reject(error?.response?.data);
  }
};

export const updateOptionInfo = async (
  optionId: number | string,
  payload: IOptionInfo
): Promise<any> => {
  try {
    const { data } = await axios.put(`/api/options/${optionId}`, payload);
    return data;
  } catch (error) {
    logError({ error, payload: payload }, 'updateOptionInfo failed');
    console.log(error?.response?.data);
    return Promise.reject(error?.response?.data);
  }
};
